import { Box, Center, Spinner } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import { iframeResizer } from "iframe-resizer";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useRef } from "react";

import { trpc } from "~/lib/trpc";

export const PublicMetrics = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { query } = useRouter();

  const { data, isFetching } = trpc.metrics.getMetabasePublicEmbedUrl.useQuery(
    {
      slug: query.slug as string,
    },
    {
      staleTime: 9 * 60 * 1000, // 9 minutes
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );

  if (isFetching) {
    return (
      <Center display="fixed" inset={0} w="100vw" h="100vh" bg="blackAlpha.800">
        <Spinner />
      </Center>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Box w="full" h="full" overflow="hidden">
      <Box
        as="iframe"
        ref={iframeRef}
        src={data.embedDashboardUrl}
        // allow-scripts + allow-same-origin is required for the iframe to load
        // but it also allows the iframe to do anything it wants to the parent page,
        // including escaping the iframe sandbox
        sandbox="allow-scripts allow-same-origin allow-forms allow-downloads allow-popups"
        referrerPolicy="no-referrer"
        w="full"
        border="none"
        m="-px"
        style={{ colorScheme: "normal" }} // Fixes iframe transparency
        onLoad={() => {
          if (!iframeRef.current) {
            return;
          }
          iframeResizer(
            {
              checkOrigin: false,
              heightCalculationMethod: "lowestElement",
              log: false,
              scrolling: true,
            },
            iframeRef.current,
          );
        }}
      />
    </Box>
  );
};
